import { render } from "./MediaLibraryLeftArea.vue?vue&type=template&id=17e81d42"
import script from "./MediaLibraryLeftArea.vue?vue&type=script&lang=js"
export * from "./MediaLibraryLeftArea.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "17e81d42"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('17e81d42', script)) {
    api.reload('17e81d42', script)
  }
  
  module.hot.accept("./MediaLibraryLeftArea.vue?vue&type=template&id=17e81d42", () => {
    api.rerender('17e81d42', render)
  })

}

script.__file = "resources/js/Pages/Media/MediaLibraryLeftArea.vue"

export default script